import {useTranslation} from "react-i18next";
import {Button, Card} from "antd";
import LayoutWithSider from "../../core/components/layout/layout-with-sider/LayoutWithSider";
import {DataGridProvider, useDataGrid} from "../../core/components/data-grid/DataGridContext";
import WorklistItemGrid from "../../app/worklist-item/worklist-item-data-grid/WorklistItemGrid";
import WorklistItemFilter from "../../app/worklist-item/worklist-item-data-grid/WorklistItemFilter";
import Flex from "../../core/components/Flex";
import CardTitle from "../../core/components/CardTitle";
import {useEffect} from "react";
import AppConfig from "../../core/service/AppConfig";
import {useModal} from "../../core/context/ModalContext";
import WorklistItemCreateEdit from "../../app/worklist-item/WorklistItemCreateEdit";
import moment from 'moment';

export default function WorklistItemGridPage()
{
    const {t} = useTranslation();
    

    useEffect(() => {
        document.title = `${t('Worklist')} | ${AppConfig.getRisTitle()}`
    }, []);

    return (
        <>
            <DataGridProvider
                defaultFilter={{
                    status: 0,
                    dateType: 'created',
                    timeFrom: moment().subtract(15, 'days').startOf('day')?.utc().toISOString(),
                    timeTo: moment().endOf('day')?.utc().toISOString()
                }}
            >
                <WorklistItemGridContent />
            </DataGridProvider>
        </>
    )
}

function WorklistItemGridContent() {
    const {t} = useTranslation();
    const {openModal, closeModal} = useModal();
    const {refreshDataGrid} = useDataGrid();

    const Title = () => {
        return (
            <Flex justifyContent={'space-between'}>
                <CardTitle title={t('Worklist')} />
            </Flex>
        )
    }

    return (
        <LayoutWithSider
            fullWidth={true}
            sidebarTitle={t('Worklist Item Filter')}
            sidebarComponent={(
                <WorklistItemFilter/>
            )}
        >
            <Card title={<Title />}>
                <WorklistItemGrid />
            </Card>
        </LayoutWithSider>
    )
}
